import { IndicatorInput_InputType } from '../proto/generated/indicator'
import { ChartPatternBias } from '../util/IndicatorUtils/patterns/chartPatternTypes'

/** TradingView built-in candlestick pattern inputs */
export const DETECT_TREND_BASED_ON_OPTIONS = ['SMA50', 'SMA50, SMA200', 'No detection'] as const
export type DetectTrendBasedOnOption = (typeof DETECT_TREND_BASED_ON_OPTIONS)[number]

/** TradingView default label colors */
export const CANDLESTICK_PATTERN_BULLISH_MARKER_COLOR = '#2962FF'
export const CANDLESTICK_PATTERN_BEARISH_MARKER_COLOR = '#F23645'
export const CANDLESTICK_PATTERN_BULLISH_BACKGROUND_COLOR = '#2962FF14'
export const CANDLESTICK_PATTERN_BEARISH_BACKGROUND_COLOR = '#F2364514'

export const CANDLESTICK_PATTERN_INPUTS = [
    {
        title: 'Detect Trend Based On',
        code: 'DETECT_TREND_BASED_ON',
        type: IndicatorInput_InputType.STRING,
        defval: 'SMA50',
        minval: '',
        maxval: '',
        options: [...DETECT_TREND_BASED_ON_OPTIONS],
        group: 'SETTINGS',
        tooltip: '',
        display: true,
    },
]

export const getCandlestickPatternMarkerColor = (bias: ChartPatternBias = 'bullish'): string =>
    bias === 'bearish' ? CANDLESTICK_PATTERN_BEARISH_MARKER_COLOR : CANDLESTICK_PATTERN_BULLISH_MARKER_COLOR

export const getCandlestickPatternBackgroundColor = (bias: ChartPatternBias = 'bullish'): string =>
    bias === 'bearish' ? CANDLESTICK_PATTERN_BEARISH_BACKGROUND_COLOR : CANDLESTICK_PATTERN_BULLISH_BACKGROUND_COLOR

/** TradingView-style drawing defaults for candlestick pattern overlays */
export const buildCandlestickPatternDrawingSettings = (bias: ChartPatternBias = 'bullish') => {
    const markerColor = getCandlestickPatternMarkerColor(bias)
    const backgroundColor = getCandlestickPatternBackgroundColor(bias)
    return {
        priceLineColor: markerColor,
        priceLineStyle: 'solid',
        priceLineWidth: '2',
        neckLineColor: markerColor,
        neckLineStyle: 'dotted',
        neckLineWidth: '2',
        showBackground: 'true',
        backgroundColor,
        showPaneLabels: 'true',
        paneLabelColor: markerColor,
        paneLabelTextColor: '#FFFFFF',
        labelColorBullish: CANDLESTICK_PATTERN_BULLISH_MARKER_COLOR,
        labelColorBearish: CANDLESTICK_PATTERN_BEARISH_MARKER_COLOR,
        showLines: 'false',
        showPolylines: 'false',
        showLineFills: 'true',
        showLabels: 'true',
        showPriceTarget: 'false',
        indicator: 'true',
    }
}

export const CANDLESTICK_PATTERN_DETECT_TREND_INPUT_SCRIPT = `const detectTrendBasedOn = input.string({
    title: "Detect Trend Based On",
    code: "DETECT_TREND_BASED_ON",
    defval: "SMA50",
    options: ["SMA50", "SMA50, SMA200", "No detection"],
    group: GRP_SETTINGS
});`

export const CANDLESTICK_PATTERN_DETECT_OPTIONS_SCRIPT = `{
    maxPatterns: 0,
    inProgress: true,
    trendBasedOn: detectTrendBasedOn
}`
